export const AUTH_TOKEN = 'auth-token-architects';
export const isDev = process.env.NODE_ENV === "development";
export const LIST_TYPE = "LIST_TYPE";

export const PROJECTS_CATEGORY:any[] = [
    {
        uid: "architecture",
        title: "Architecture",
        program: [
            {
                uid: "office",
                title: "Office"
            },
            {
                uid: "residential",
                title: "Residential"
            },
            {
                uid: "cultural",
                title: "Cultural"
            },
            {
                uid: "urbanism",
                title: "Urbanism"
            },
            {
                uid: "product",
                title: "Product"
            }
        ]
    },
    {
        uid: "graphics",
        title: "Graphics",
        program: [
            {
                uid: "branding",
                title: "Branding"
            },
            {
                uid: "web",
                title: "Web"
            },
            {
                uid: "publication",
                title: "Publication"
            },
            {
                uid: "video",
                title: "Video"
            },
            {
                uid: "package",
                title: "Package"
            }
        ]
    }
];


export const getCategoryTypeTitle = (uid:string) => {
    const _categoryType:any = PROJECTS_CATEGORY.find((_type:any) => _type.uid === uid);
    return _categoryType.title;
}

export const getCategoryProgramTitle = (typeUid:string, uid:string) => {
    const _categoryType:any = PROJECTS_CATEGORY.find((_type:any) => _type.uid === typeUid);
    const _categoryProgram = _categoryType.program.find((_program:any) => _program.uid === uid);
    return _categoryProgram.title;
}


export const setListTypeByProjects = (type:string) => {
    localStorage.setItem(LIST_TYPE, type);
}

export const getListTypeByProjects = () => {
    const listType = localStorage.getItem(LIST_TYPE);
    return listType ? listType : 'list';
}


export const groupedByKey = (list:any[], keyGetter:(item:any)=>string) => {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}


export const getPostType = (post:any) => {
    let result = post.type;

    if( post.type === "introduction" ) {
        result = 'news';
    }

    if( post.end !== null ) {
        result = post.end.category;
    }
    return result;
}



export const boldRegex = /bold\("(.*?)"\)/;